<template>
  <a class="collaboratorCard" :href="href" target="_blank">
    <div class="collaboratorCard_container">
      <div class="collaboratorCard_logo" :class="collaboratorTypeClass">
        <img :src="logoSrc" :alt="name" target="_blank" rel=”noopener”>
      </div>
      <span class="collaboratorCard_category">{{ categoryType }}</span>
      <h3 class="collaboratorCard_name">{{ name }}</h3>
    </div>
  </a>
</template>

<script>
export default {
  name: 'CollaboratorCard',
  props: {
    collaboratorType: {
      required: true,
      type: String,
      validator: (value) => {
        return ['Goodpatch', 'Slalom'].indexOf(value) !== -1
      }
    },
    name: {
      required: true,
      type: String
    },
    categoryType: {
      required: true,
      type: String
    },
    logoSrc: {
      required: true,
      type: String
    },
    href: {
      required: true,
      type: String
    }
  },
  computed: {
    collaboratorTypeClass () {
      return this.collaboratorType === 'Goodpatch' ? 'collaboratorCard_logo--Goodpatch' : 'collaboratorCard_logo--Slalom'
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/mixins';
@import '../../assets/stylesheets/variables';

.collaboratorCard {
  display: flex;
  background: #fff;
  @include bpOnlyPc() {
    width: 100%;
    height: 350px;
    max-width: 430px;
  }
  @include bpOnlySp() {
    width: 100%;
    height: 270px;
    max-width: 350px;
  }
  &_container {
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: center;
    @include bpOnlyPc() {
      padding: 80px 24px;
    }
    @include bpOnlySp() {
      padding: 50px 24px;
    }
  }
  &_logo {
    display: flex;
    @include bpOnlyPc() {
      width: 266px;
      height: 57px;
    }
    @include bpOnlySp() {
      width: 186px;
      height: 57px;
    }
    margin: auto;
    align-items: flex-end;
    justify-content: center;
    &--Goodpatch {
      img {
        width: 100%;
      }
    }
    &--Slalom {
      img {
        @include bpOnlyPc() {
          height: 100%;
        }
        @include bpOnlySp() {
          width: 100%;
        }
      }
    }
  }
  &_category {
    display: inline-block;
    font-size: 16px;
    margin-top: auto;
    color: $buildNavy;
  }
  &_name {
    font-size: 22px;
    font-weight: 500;
    line-height: 1.4;
    margin-top: 8px;
    color: $buildNavy;
  }
}
</style>
